/**
 * Determines if the kick-out action should use the dedicated kick-out endpoint
 * (PC Open path) vs the standard heat-not-used endpoint.
 *
 * Legacy rule: if recip is already "Implanted" or "Pregnant", the kick-out
 * performs a Preg Check Open; otherwise it records a Heat Not Used.
 */
const KICKOUT_STATUSES = new Set(['implanted', 'pregnant']);

export function shouldUseKickOutEndpoint(
  recipStatus: string | null | undefined,
): boolean {
  if (!recipStatus) return false;
  return KICKOUT_STATUSES.has(recipStatus.toLowerCase());
}

/**
 * Minimal shape needed by the HeatNotUsedDialog to perform a kick-out.
 * Both DataEntryRecord and RecipQueueItem can satisfy this.
 */
export interface KickOutTarget {
  recipId: string;
  recipQueueId: number;
  recipStatus: string;
}
